import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/styles';

import { makeGraph } from 'lib/commonLib';
import { freqTtimeGraph } from 'lib/api/report';

import CurrentStatus from 'components/atoms/CurrentStatus';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import MultiplexChart from 'components/organisms/Chart/MultiplexChart';

const styles = (theme) => ({
  graphWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      width: '100%',
    },
  },
});
let graphList = new Array([]);
graphList['01'] = [
  {
    data: { line: ['T_TIME_CLICK_RATE', 'T_TIME_ROAS', 'T_TIME_CNVRS_RATE'] },
    yAxisData: {
      left: {
        T_TIME_CNVRS_RATE: { isPercent: true },
        T_TIME_CLICK_RATE: { isPercent: true },
        individually: true,
      },
      right: {
        T_TIME_ROAS: true,
        individually: true,
      },
    },
    referenceLine: {
      T_TIME_CLICK_RATE: {
        type: 'average',
        label: 'CTR AVG',
        visibleValue: true,
      },
      T_TIME_ROAS: {
        type: 'average',
        label: 'ROAS AVG',
        visibleValue: true,
      },
      T_TIME_CNVRS_RATE: {
        type: 'average',
        label: 'CVR AVG',
        visibleValue: true,
      },
    },
    customizeData: {
      T_TIME_CNVRS_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },
      T_TIME_ROAS: {
        tooltipFormat: '0.00',
        isPercent: true,
      },
      T_TIME_CLICK_RATE: {
        tooltipFormat: '0.000',
        isPercent: true,
      },
    },
  },
];

graphList['02'] = [
  {
    data: {
      bar: ['PAR_EPRS_CNT', 'EXHS_AMT'],
      line: ['T_TIME_ECPM'],
    },
    yAxisData: {
      left: {
        PAR_EPRS_CNT: true,
        EXHS_AMT: true,
      },
      right: {
        T_TIME_ECPM: true,
      },
    },
    referenceLine: {
      PAR_EPRS_CNT: {
        type: 'average',
        label: i18next.t('노출수'),
        visibleValue: true,
      },
      EXHS_AMT: {
        type: 'average',
        label: i18next.t('소진'),
        visibleValue: true,
      },
      T_TIME_ECPM: {
        type: 'average',
        label: i18next.t('ECPM'),
        visibleValue: true,
      },
    },
  },
];

class StatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      graphData: [],
      graphComponent: {},
      infoMessage: '',
      loading: false,
      error: false,
    };
  }

  getData = (type) => {
    const { params, t } = this.props;
    const { sDate, eDate } = params;
    const { switchDatas } = this.props;

    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: sDate.substring(0, 6),
          endDate: eDate.substring(0, 6),
        }),
      }),
    });
    freqTtimeGraph({
      ...params,
      sDate: sDate.substring(0, 6),
      eDate: eDate.substring(0, 6),
    })
      .then((response) => {
        const { data } = response.data;
        const primitiveData = data;
        this.setState({
          ...this.state,
          //primitiveData: data,
          loading: false,
          error: false,
        });

        for (const value of switchDatas) {
          this.setGraphData(graphList[value][0], primitiveData, value);
        }
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    return originalDate;
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  setGraphData = (
    {
      title,
      data,
      yAxisData,
      customizeData: customize,
      isPercent = false,
      referenceLine,
    },
    primitiveData,
    switchData
  ) => {
    if (typeof data !== 'undefined') {
      const {
        graphData,
        dataKeys,
        customizeData,
        keyLabel,
        stackId,
        referenceData,
      } = makeGraph({ data, customize, primitiveData, referenceLine });

      let title;
      const result = (
        <MultiplexChart
          xAxisTick={this.xAxisTick}
          makeLabel={this.makeLabel(false)}
          data={graphData}
          dataKeys={dataKeys}
          customizeData={customizeData}
          keyLabel={keyLabel}
          stackId={stackId.length !== 0 ? stackId.join('$') : null}
          yAxisData={yAxisData}
          legend
          title={title}
          isPercent={isPercent}
          key={switchData}
          referenceLine={referenceData}
        />
      );

      const { graphComponent } = this.state;

      graphComponent[switchData] = result;

      this.setState({
        ...this.state,
        graphComponent: graphComponent,
      });
    }
  };

  render() {
    const { handleRefesh } = this;
    const { switchDatas } = this.props;
    let { infoMessage, graphComponent, loading, error } = this.state;

    return (
      <>
        {loading || error ? (
          <CurrentStatus type={loading ? 'table' : error && 'error'} />
        ) : (
          <>
            {switchDatas.map((type, i) => {
              let switchLabel = '';

              if (typeof graphComponent[type] === 'undefined') {
                return null;
              }

              if (switchDatas[i] === '01')
                switchLabel = 'T-Time별 CTR / ROAS / 전환율 ';
              else if (switchDatas[i] === '02')
                switchLabel = 'T-Time별 노출수 / 소진 / eCPM ';

              return (
                <React.Fragment key={type}>
                  <SwitchingArea
                    title={
                      <>
                        <InfoTitleArea
                          title={switchLabel}
                          tooltipTitle={infoMessage}
                          iconType="fainfoCircle"
                          iconColor="graph"
                        />
                      </>
                    }
                    handleRefesh={handleRefesh}
                  >
                    {graphComponent[type]}
                  </SwitchingArea>
                </React.Fragment>
              );
            })}
          </>
        )}
      </>
    );
  }
}

export default withRouter(
  withTranslation()(
    connect(
      ({ locale }) => ({
        locale: locale.locale,
      }),
      null
    )(withStyles(styles)(withTheme(StatisticsGraph)))
  )
);
